import {useQuery} from '@tanstack/react-query';
import {getPublicCompressed} from '@toruslabs/eccrypto';
import {Web3AuthNoModal} from '@web3auth/no-modal';
import {Hex} from 'viem';
import {UseAccountReturnType} from 'wagmi';

export type Web3AuthSignatureGroup = {
  idToken: string;
  publicAddress: Hex;
  appPubKey?: string;
};

export const useWeb3AuthSignatureGroup = (web3Auth: Web3AuthNoModal | null, accountResult: UseAccountReturnType) =>
  useQuery({
    queryKey: ['web3auth-signature-group', accountResult.address],
    queryFn: async () => {
      const {idToken} = await web3Auth!.authenticateUser();

      if (web3Auth!.connectedAdapterName === 'openlogin') {
        const app_scoped_privkey = (await web3Auth!.provider?.request({
          method: 'eth_private_key',
        })) as any;
        const appPubKey = getPublicCompressed(Buffer.from(app_scoped_privkey.padStart(64, '0'), 'hex')).toString('hex');

        return {
          idToken,
          publicAddress: accountResult.address as Hex,
          appPubKey,
        };
      }

      return {
        idToken,
        publicAddress: accountResult.address as Hex,
      };
    },
    enabled: !!web3Auth && !!web3Auth.connected && !!accountResult.address && !!accountResult.isConnected,
    gcTime: 0,
    retry: false,
    retryOnMount: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
